import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  pageContentWrapper: {
    '&&': {
      flexGrow: 0,
    },
    '& main': {
      paddingTop: 0,
    },
  },
  placeholder: {
    paddingTop: 40,
    margin: '0 auto',
    maxWidth: 800,
    width: '100%',
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    '& fieldset': {
      margin: '0 auto',
      maxWidth: 800,
      width: '100%',
    },
  },
  formRow: {
    maxWidth: '100%',
  },
  submit: {
    fontSize: 18,
    height: 52,
    borderRadius: 50,
    minWidth: 240,
    margin: '0 auto',
    [breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  footer: {
    maxWidth: 600,
    textAlign: 'right',
  },
  footerFirstScreen: {
    textAlign: 'center',
  },
}));
